import * as ActionTypes from "./ActionTypes";
export const activateLoader = (loading) => {
  return {
    type: ActionTypes.ACTIVATE_LOADER,
    loading,
  };
};
